import React, { useState } from 'react';

interface SafeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackGradient?: string;
  wrapperStyle?: React.CSSProperties;
}

/**
 * An <img> that never shows a broken-image glyph. If the remote asset
 * (e.g. a temporary Unsplash placeholder) fails to load, it quietly
 * swaps in a brand-coloured gradient panel instead.
 */
const SafeImage: React.FC<SafeImageProps> = ({
  fallbackGradient = 'linear-gradient(145deg, #e8f4f5, #d1eaed)',
  wrapperStyle,
  style,
  alt = '',
  ...rest
}) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <div style={{ background: fallbackGradient, width: '100%', height: '100%', ...wrapperStyle }} />;
  }

  return (
    <img
      {...rest}
      alt={alt}
      onError={() => setFailed(true)}
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', ...style }}
    />
  );
};

export default SafeImage;
